export const appsStoreLinks = {
  android: 'https://app.adjust.com/186jcc35',
  ios: 'https://app.adjust.com/18wci921',
  unique: 'https://app.adjust.com/1agb4obq_1aljnt8i',
  gamification:
    'https://hlfx.adj.st/programa-de-pontos?adj_t=1eqqb07v_1eucyisd&adj_fallback=https://monett.app/programa-de-pontos%3Fxcode%3DEN-MNT-FPP-APP-X-X-JK1-LAPP-JK1%26utm_source%3DMNT%26utm_medium%3DX%26utm_content%3DFPP%26utm_campaign%3DEN-MNT-FPP-APP-X-X-JK1-LAPP-JK1%26campaignId%3D701TW000005QawGYAS&adj_redirect_macos=https://monett.app/programa-de-pontos%3Fxcode%3DEN-MNT-FPP-APP-X-X-JK1-LAPP-JK1%26utm_source%3DMNT%26utm_medium%3DX%26utm_content%3DFPP%26utm_campaign%3DEN-MNT-FPP-APP-X-X-JK1-LAPP-JK1%26campaignId%3D701TW000005QawGYAS&adjust_deeplink_js=1',
  eqi: {
    trader: {
      android:
        'https://play.google.com/store/apps/details?id=com.btg.pactual.homebroker.mobile.eqi',
      ios: 'https://apps.apple.com/br/app/eqi-trader/id1606793010',
    },
  },
};
